import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ChargeDiscrepancies } from "@app/models/chargesettlement/charge-deviations.model";
import { Charge, PaymentMethod } from "@app/models/chargesettlement/charge.model";
import { PaginatedList } from "@app/models/common/paginated-list.class";
import { environment } from "@environments/environment";

@Injectable()
export class ChargeSettlementService {

  private uri: string = `${environment.routes.apiEndpoint}/chargesettlement`;

  constructor(private http: HttpClient) { }

  getCharges(
    locationIds: string[] = [],
    paymentMethods: PaymentMethod[] = [],
    completedAtFrom: Date | null = null,
    completedAtTo: Date | null = null,
    amountFrom: number | null = null,
    amountTo: number | null = null,
    isLostRevenue: boolean | null = null,
    correlationId: string | null = null,
    sortByField: string = 'startedAt',
    sortDescending: boolean = true,
    pageIndex: number = 1,
    pageSize: number = 100
  ) {
    let filters = `pageSize=${pageSize}&pageIndex=${pageIndex}&sortByField=${sortByField}&sortDescending=${sortDescending}`;
    if (locationIds.length) filters += `&locationIds=${locationIds.join('&locationIds=')}`;
    if (paymentMethods.length) filters += `&paymentMethods=${paymentMethods.join('&paymentMethods=')}`;
    if (completedAtFrom) filters += `&completedAtFrom=${completedAtFrom.toISOString()}`;
    if (completedAtTo != null) filters += `&completedAtTo=${completedAtTo.toISOString()}`;
    if (amountFrom !== null) filters += `&amountFrom=${amountFrom}`;
    if (amountTo !== null) filters += `&amountTo=${amountTo}`;
    if (isLostRevenue !== null) filters += `&isLostRevenue=${isLostRevenue}`;
    if (correlationId) filters += `&correlationId=${correlationId}`;

    return this.http.get<PaginatedList<Charge>>(`${this.uri}/sales?${filters}`);
  }

  getChargeDeviations(
    dateFrom: Date | null = null,
    dateTo: Date | null = null,
    paymentMethods: PaymentMethod[] = [],
  ) {
    let filters = '';
    if (dateFrom != null) filters += `&dateFrom=${dateFrom.toISOString()}`;
    if (dateTo != null) filters += `&dateTo=${dateTo.toISOString()}`;
    if (paymentMethods.length) filters += `&paymentMethods=${paymentMethods.join('&paymentMethods=')}`;
    return this.http.get<ChargeDiscrepancies>(`${this.uri}/sales/discrepancies?${filters}`);
  }

  postExportVisma() {
    return this.http.post(`${this.uri}/export/b2c/run`, null);
  }

  patchChargeLostRevenue(chargeId: string, lostRevenueReason: string) {
    return this.http.patch(`${this.uri}/sales/${chargeId}/lost-revenue`, {
      reason: lostRevenueReason
    });
  }
}
